import Vue from 'vue'
import './plugins/axios'
import VueDraggableResizable from 'vue-draggable-resizable'
import App from './App.vue'
import router from './router'
import VueRouterBackButton from 'vue-router-back-button'
import Lightbox from 'vue-easy-lightbox'
import Tooltip from 'vue-directive-tooltip';


// Vue.use(Router)

Vue.use(VueRouterBackButton, { router }, Lightbox)

Vue.use(require('vue-chartist'))

Vue.use(Tooltip)

Vue.config.productionTip = false

Vue.component('vue-draggable-resizable', VueDraggableResizable)


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
